import type { ReactNode } from 'react';

interface CandidateSectionTitleProps {
  children: ReactNode;
  hint?: string;
  id?: string;
}

export function CandidateSectionTitle({
  children,
  hint,
  id,
}: CandidateSectionTitleProps) {
  return (
    <div className="flex flex-col gap-0.5">
      <h2 className="text-[13px] leading-[18px] font-semibold" id={id}>
        {children}
      </h2>
      {hint && <p className="text-[13px] text-neutral-500">{hint}</p>}
    </div>
  );
}
